/*
 * Copyright (c) 2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import useGetUrlParams from "../../../../../hooks/useGetUrlParams";
import {useAppDispatch, useAppSelector} from "../../../../../redux/hooks";
import {useSelectRefreshTableCount} from "../../../../../redux/ducks/Wizard/SliceProvider";
import {usePostRequest} from "../../../../../api/helper";
import {VEHICLE_PROGRAMS_CONSTANTS} from "../../constants";
import * as React from "react";
import {useEffect, useState} from "react";
import {selectTriggerRefreshAfterNewAdasProgramAdded, setIsLoadingDevelopmentStageData, setVehicleProgramsSelectedDevelopmentStageData} from "../../../../../redux/ducks/VehicleProgramsDetails/slice";
import SensorInformation from "../SensorInformation";
import SensingSysPerf from "../Tabs/SensingSysPerfTab/SensingSysPerf";
import {HorizontalTabs} from "../../../../components/Tabs/HorizontalTabs";


type Params = {
  adasProgramId?: string;
  developmentStageId?: string;
  vehicleProgramId?: string;
};

export function useAdasProgramDataFetcher() {
  const dispatch = useAppDispatch();
  const netHandleGetAdasProgramData = usePostRequest(VEHICLE_PROGRAMS_CONSTANTS.itemDetails.endpoints.getAdasProgramData);

  const fetchAdasProgramData = ({ adasProgramId, developmentStageId, vehicleProgramId }: Params) => {
    if (!adasProgramId) return;
    dispatch(setIsLoadingDevelopmentStageData(true));
    netHandleGetAdasProgramData({ adasProgramId, developmentStageId, vehicleProgramId })
      .then((res: any) => {
        dispatch(setVehicleProgramsSelectedDevelopmentStageData(res));
      })
      .catch((err: any) => {
        console.log("error", err);
        dispatch(setVehicleProgramsSelectedDevelopmentStageData(null));
      })
      .finally(() => {
        dispatch(setIsLoadingDevelopmentStageData(false));
      });
  };

  return fetchAdasProgramData;
}

const AdasItemDetails = () => {
  const {adasProgramId, developmentStageId, vehicleProgramId} = useGetUrlParams()

  const refreshAfterNewDevelopmentStageAdded = useSelectRefreshTableCount()
  const refreshAfterAdasProgramUpdated = useAppSelector(selectTriggerRefreshAfterNewAdasProgramAdded)
  const fetchAdasProgramData = useAdasProgramDataFetcher();

  useEffect(() => {
    fetchAdasProgramData({
      adasProgramId,
      developmentStageId,
      vehicleProgramId
    });
  }, [adasProgramId, developmentStageId, vehicleProgramId, refreshAfterNewDevelopmentStageAdded, refreshAfterAdasProgramUpdated]);

  const [htabs, setHtabs] = useState<any[]>([])
  useEffect(() => {
    const tab1 = {
      name: 'Sensor Information',
      content: <SensorInformation/>
    }
    const tab2 = {
      name: 'Sensing System Information and Verification',
      content: <SensingSysPerf/>
    }
    setHtabs([tab1, tab2])
  }, [])

  return (
    <div style={{height: '100%', overflow: 'auto'}}>
      <HorizontalTabs initContent={null} initHtabIndex={0} horizontalTabs={htabs} align={'left'}
                      uid={'htabs-adas'}
      />
    </div>
  )
}

export default AdasItemDetails